module.exports = __webpack_public_path__ + "img/icon-info-light-blue.e9ed46ce.svg";